export const aboutInfo = {
  brandName: '91n.com',
  tagline: '值得信赖的网络综合服务平台',
  introduction: '91n.com 致力于为广大用户提供安全、便捷、高效的网络服务体验。自成立以来，我们始终秉持"用户至上、服务为本"的理念，持续优化平台功能，提升服务质量。目前，91n.com 已服务超过百万用户，涵盖信息浏览、互动交流、资源获取等多个领域。',
  history: [
    { year: '2018', event: '91n.com 平台正式上线，开启网络服务新篇章' },
    { year: '2019', event: '完成首轮功能升级，新增搜索与个性化推荐系统' },
    { year: '2020', event: '用户数量突破 50 万，推出移动端适配版本' },
    { year: '2021', event: '安全体系全面升级，引入二次验证与异常检测机制' },
    { year: '2022', event: '社区互动功能上线，用户参与度大幅提升' },
    { year: '2023', event: '平台架构优化，页面加载速度提升 50%' },
    { year: '2024', event: '注册用户突破百万，推出高级会员服务' },
    { year: '2025', event: '完成智能化升级，AI 驱动个性化体验' },
  ],
  reputation: [
    { icon: 'ri-shield-check-line', label: '安全可靠', description: '采用行业领先的安全技术，全方位保护用户数据和隐私安全' },
    { icon: 'ri-user-heart-line', label: '用户信赖', description: '累计服务超过百万用户，满意度持续保持 98% 以上' },
    { icon: 'ri-flashlight-line', label: '高效便捷', description: '持续优化平台性能，确保流畅快速的访问体验' },
    { icon: 'ri-customer-service-2-line', label: '贴心服务', description: '7×24 小时客服支持，快速响应用户各类问题和需求' },
  ],
  contact: {
    email: 'support@91n.com',
    serviceTime: '周一至周日 9:00 - 21:00',
    responseTime: '平均响应时间：2 小时内',
  },
};